import React from 'react';
import PropTypes from 'prop-types';

import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useSizeStyles = makeStyles({
  xxs: { height: 3 },
  xs: { height: 8 },
  sm: { height: 13 },
  md: { height: 16 },
  lg: { height: 22 }
});

const useStyles = makeStyles(theme => ({
  root: ({ hasBorderRadius }) => ({
    borderRadius: hasBorderRadius ? theme.shape.borderRadius * 5 : 0
  }),
  bar: ({ color, borderColor, normalizedScore, hasBorderRadius }) => ({
    borderRadius: hasBorderRadius ? theme.shape.borderRadius * 5 : 0,
    border: borderColor ? `1px solid ${borderColor}` : null,
    backgroundColor: color,
    width: `${normalizedScore}%`,
    transform: 'none !important',
    display: normalizedScore ? 'block' : 'none'
  }),
  colorPrimary: ({ backgroundColor }) => ({
    backgroundColor: backgroundColor || theme.palette.grey[100]
  })
}));

export const ProgressBar = ({ max, value, color, borderColor, size, backgroundColor, hasBorderRadius = true }) => {
  const trimmedScore = Math.min(max, Math.max(0, value));
  const normalizedScore = parseInt(100 * trimmedScore / max, 10);
  const classes = useStyles({ color, borderColor, normalizedScore, backgroundColor, hasBorderRadius });
  const sizeClasses = useSizeStyles();

  return (
    <LinearProgress
      className={sizeClasses[size || 'md']}
      variant='determinate'
      value={normalizedScore}
      classes={classes}
    />
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number,
  color: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  valueText: PropTypes.node,
  hasBorderRadius: PropTypes.bool
};

ProgressBar.defaultProps = {
  max: 100,
  size: 'md'
};

export default ProgressBar;
